import { render } from "./AccessDashboardView.vue?vue&type=template&id=2b9bd9e6&scoped=true"
import script from "./AccessDashboardView.vue?vue&type=script&lang=js"
export * from "./AccessDashboardView.vue?vue&type=script&lang=js"

import "./AccessDashboardView.vue?vue&type=style&index=0&id=2b9bd9e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9bd9e6"]])

export default __exports__